import { Injectable, signal } from '@angular/core';

export type ThemeMode = 'light' | 'dark' | 'system';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly modeState = signal<ThemeMode>(this.readStored());
  readonly mode = this.modeState.asReadonly();

  constructor() {
    this.apply(this.modeState());
  }

  setMode(mode: ThemeMode): void {
    localStorage.setItem('portbar.theme', mode);
    this.modeState.set(mode);
    this.apply(mode);
  }

  private readStored(): ThemeMode {
    const stored = localStorage.getItem('portbar.theme');
    return stored === 'light' || stored === 'dark' ? stored : 'system';
  }

  private apply(mode: ThemeMode): void {
    const root = document.documentElement;
    if (mode === 'system') root.removeAttribute('data-theme');
    else root.setAttribute('data-theme', mode);
  }
}
